module.exports = __webpack_public_path__ + "img/bonus-icon.aef21165.svg";